module.exports = __webpack_public_path__ + "static/media/gpp_bad.bb89572a.svg";